import {$, PageCollection} from 'simpli-web-sdk'
import RelatorioGeracao from '@/model/resource/RelatorioGeracao'

export default class RelatorioGeracaoCollection extends PageCollection<RelatorioGeracao> {
  constructor(
    filter = {},
    endPoint: string | null = null,
    perPage: number | null = 10,
    currentPage: number | null = 0,
  ) {
    super(RelatorioGeracao, filter, perPage, currentPage)
    this.endpoint = endPoint
  }

  async list(spinner = 'listRelatorioGeracao') {
    const fetch = async () => await this.GET(`/user/relatorio-geracao`)
    return await $.await.run(fetch, spinner)
  }
}
